import { render, staticRenderFns } from "./projectlist.vue?vue&type=template&id=09139bb5&scoped=true"
import script from "./projectlist.vue?vue&type=script&lang=js"
export * from "./projectlist.vue?vue&type=script&lang=js"
import style0 from "./projectlist.vue?vue&type=style&index=0&id=09139bb5&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09139bb5",
  null
  
)

export default component.exports